import React, { Component } from 'react';

import ContentWrapper from '../../components/ContentWrapper';
import PageTitle from '../../components/PageTitle';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import './Amenities.css';

import { Link } from 'react-router-dom';

import { 
  loadAmenities,
  removeAmenity,
} from '../../reducers/amenities';

class Amenities extends Component {

  componentWillReceiveProps = () => {
  }

  getFileURL = (absoluteURL) => {
    return `${absoluteURL}`;
  }

  removeAmenity = (amenity) => {
    if(window.confirm(`Do you want to remove ${amenity.amenity_name}?`)){
      this.props.removeAmenity(amenity.amenity_id);
    }
  }

  render() {
    return (
      <ContentWrapper>
        <div className="inner-content">
          <PageTitle>Amenities</PageTitle>

          <div className="container-fluid">
            <div className="row" role="toolbar" aria-label="Toolbar with button groups">

              <div className="input-group col-md-4">
                {/* <input type="text" className="form-control" aria-label="Text input with dropdown button" placeholder="Search Amenity" /> */}
              </div>

              <div className="col-md-4 offset-md-4">
                <Link to="/amenities/add" className="btn btn-primary float-right">Add Amenity</Link>
              </div>

            </div>
            
            <table className="table table-striped table-hover">
              <thead>
                <tr>
                  <th scope="col">Amenity</th>
                  <th scope="col" width="200">Actions</th>
                </tr>
              </thead>
              {this.props.isLoadingAmenities &&
                <tbody>
                  <tr>
                    <td colSpan="2" className="text-center"><em>Loading Amenities</em></td>
                  </tr>
                </tbody>
              }
              {!this.props.isLoadingAmenities && this.props.amenities.length === 0 &&
                <tbody>
                  <tr>
                    <td colSpan="2" className="text-center"><em>0 Amenities</em></td>
                  </tr>
                </tbody>
              }
              {this.props.amenities &&
                <tbody>
                  {this.props.amenities.map((amenity, idx) => {
                    return (
                      <tr key={`amenity-${idx}`} className="amenity-item">
                        <td>
                          <img src={this.getFileURL(amenity.amenity_logo)} className="rounded float-left amenity-logo" alt={`${amenity.amenity_name}`}></img>
                          <strong>{amenity.amenity_name}</strong><br/>
                          {amenity.amenity_description}
                        </td>
                        <td>
                          <Link to={`/amenities/${amenity.amenity_id}`} className="btn btn-outline-secondary btn-sm">Edit</Link>&nbsp;
                          <button className="btn btn-outline-danger btn-sm" onClick={() => this.removeAmenity(amenity)}>Remove</button>&nbsp;
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              }
            </table>
          </div>
        </div>
      </ContentWrapper>
    )
  }
}


const mapStateToProps = state => ({
  amenities: state.amenities.amenities,
  isLoadingAmenities: state.amenities.isLoadingAmenities,
  role: state.account.role,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      loadAmenities,
      removeAmenity,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Amenities);


// WEBPACK FOOTER //
// ./src/modules/Amenities/Amenities.js